import * as utils from '../utilities/utils';

var handlers = {}, 
    messageHandlerRegistered = false;

export function messageHandler(e){
    for(let keyword in handlers){
        if(handlers.hasOwnProperty(keyword)){
            const dataString = utils.formatYodleeData(e.data); 
            if(dataString.indexOf(keyword) !== -1){
                const handler = handlers[keyword];
                if(typeof handler === 'function'){
                    handler(e);
                    break;
                }
            }
        }
    }
}

// register DOM window message handler for notifications from the Yodlee response/error page inside the iframe.
export function registerMessageHandler (keywords, handler){

    for(let i=0;i<keywords.length;i++){
        const keyword = keywords[i];
        handlers[keyword] = handler;
    }

    // start to listen
    if(!messageHandlerRegistered){
        utils.registerMessageHandler(messageHandler);
        messageHandlerRegistered = true;
    }
}



// WEBPACK FOOTER //
// ./application/src/services/msgsvc.js